// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4352141e","239":"5dceb92e","455":"21fe442e"}[chunkId] + ".chunk.js";
};